import { render, staticRenderFns } from "./companyBasic.vue?vue&type=template&id=3f76eed2&scoped=true&"
import script from "./companyBasic.vue?vue&type=script&lang=js&"
export * from "./companyBasic.vue?vue&type=script&lang=js&"
import style0 from "./companyBasic.vue?vue&type=style&index=0&id=3f76eed2&scoped=true&lang=css&"
import style1 from "./companyBasic.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76eed2",
  null
  
)

export default component.exports